"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertLightToOverride = void 0;
const LightOverride_1 = require("../objects/LightOverride");
function convertLightToOverride(keyVal, light) {
    if (!light) {
        throw new Error("Light is undefined");
    }
    const _light = light; // Cast to any, lights can be DirectionalLight, PointLight or SpotLight
    var lightType;
    switch (light.type) {
        case "DirectionalLight":
            lightType = "DIRECTIONAL" /* DIRECTIONAL */;
            break;
        case "PointLight":
            lightType = "POINT" /* POINT */;
            break;
        case "SpotLight":
            lightType = "SPOT" /* SPOT */;
            break;
        default: throw new Error("Undefined light type: " + light.type);
    }
    const lightOverride = new LightOverride_1.LightOverride();
    lightOverride.id = keyVal.key;
    lightOverride.type = lightType;
    lightOverride.position.x = _light.position.x;
    lightOverride.position.y = _light.position.y;
    lightOverride.position.z = _light.position.z;
    lightOverride.rotation.x = _light.rotation.x;
    lightOverride.rotation.y = _light.rotation.y;
    lightOverride.rotation.z = _light.rotation.z;
    lightOverride.scale.x = _light.scale.x;
    lightOverride.scale.y = _light.scale.y;
    lightOverride.scale.z = _light.scale.z;
    lightOverride.color = "#" + _light.color.getHexString();
    lightOverride.intensity = _light.intensity;
    lightOverride.distance = _light.distance;
    lightOverride.angle = _light.angle;
    lightOverride.penumbra = _light.penumbra;
    lightOverride.decay = _light.decay;
    return lightOverride;
}
exports.convertLightToOverride = convertLightToOverride;
